import { IssueSourceDtoAppEnum } from '@issuemanager/api-client';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type SourceAppLabelProps = {
  sourceApp: IssueSourceDtoAppEnum | null;
};

export function IssueSourceAppLabel({ sourceApp }: SourceAppLabelProps) {
  const issueSourceApps = useIssueSourceApplications();
  const issueSourceApp = issueSourceApps.find(
    (item) => item.value === sourceApp,
  );

  if (sourceApp == null) {
    return null;
  }

  return issueSourceApp?.label ?? null;
}

export interface IssueSourceApplicationData {
  id: string;
  value: IssueSourceDtoAppEnum | null;
  label: string;
}

export function useIssueSourceApplications() {
  const { t } = useTranslation();

  const issueSourceApplications: IssueSourceApplicationData[] = useMemo(
    () => [
      {
        id: '1',
        value: IssueSourceDtoAppEnum.RiskManager,
        label: t('sourceApplications.riskManager'),
      },
      {
        id: '2',
        value: IssueSourceDtoAppEnum.Audit,
        label: t('sourceApplications.audit'),
      },
      {
        id: '3',
        value: IssueSourceDtoAppEnum.InternalControls,
        label: t('sourceApplications.internalControls'),
      },
      {
        id: '4',
        value: IssueSourceDtoAppEnum.IssueManagement,
        label: t('sourceApplications.issueManagement'),
      },
      {
        id: '5',
        value: IssueSourceDtoAppEnum.AssetManager,
        label: t('sourceApplications.assetManager'),
      },
    ],
    [t],
  );

  return issueSourceApplications;
}
